import { Component, effect, input, output, signal, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-bottom-sheet',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './bottom-sheet.component.html',
  styleUrls: ['./bottom-sheet.component.scss']
})
export class BottomSheetComponent {
  isOpen = input<boolean>(false);
  isClosed = output<boolean>();
  isOpenState = false;

  constructor() {
    effect(() => {
      this.isOpenState = this.isOpen();
    });
  }
  
  toggleSheet() {
    const newState = !this.isOpenState;
    this.isOpenState = newState;
    this.isClosed.emit(newState);
    document.body.style.overflow = newState ? 'hidden' : '';
  }
}
